import React from "react";

import { Typography } from "antd";
import styled from "styled-components";

import { AutomationCommandProps } from "../types/automation";
import { LoadSavedFilterPayload } from "../types/payloads";

const { Text } = Typography;
const LoadProjectCommand: React.FC<AutomationCommandProps> = (props) => {
  const payload = props.command.payload as LoadSavedFilterPayload;
  return (
    <RootContainer>
      {payload?.projectName ? (
        <div>
          Load <Text strong>{payload?.projectName}</Text>
          {"  "} Project
        </div>
      ) : (
        <div>No Project Selected</div>
      )}
    </RootContainer>
  );
};

export default LoadProjectCommand;

const RootContainer = styled.div``;
